import type { AccountRole } from "@/features/accounts/api/accountsApi";
import { useCurrentAccount } from "@/features/accounts/hooks/useCurrentAccount";
import type { ReactNode } from "react";

type Props = {
  roles: AccountRole[];
  children: ReactNode;
  fallback?: ReactNode;
};

export function RoleGate({ roles, children, fallback = null }: Props) {
  const { currentMembership, isLoading } = useCurrentAccount();
  if (isLoading) return null;
  if (!currentMembership || !roles.includes(currentMembership.role)) return <>{fallback}</>;
  return <>{children}</>;
}
